import { isManagerUser } from '@/utils/panelMode'

export const COUNTER_ID = 53599684
const ORIGIN = 'https://gorkyliquid.ru'
const STORAGE_KEY = 'gl_analytics_sent_v1'
const SESSION_KEY = 'gl_analytics_visit_v2'
const GOALS = new Set('product_viewed course_viewed cart_added checkout_started payment_redirect payment_succeeded qa_purchase print_request_created callback_requested ai_first_question ai_product_clicked'.split(' '))
const sent = new Set()
let active = false
let installed = false
let currentPath = '/'
let previousUrl = ''
let initial = true
let store
let visit = {}
let pendingHit = false
let hitTimer

function allowed () {
  return typeof window !== 'undefined' && ['gorkyliquid.ru', 'www.gorkyliquid.ru'].includes(window.location.hostname)
}

function pathOnly (value) { return String(value || '/').split(/[?#]/)[0] }

export function analyticsPage (value) {
  const path = pathOnly(value)
  // Fixed account categories: never disclose order, lesson, conversation or reset IDs.
  if (/^\/(login|registration|reset-password|forgot-password)(\/|$)/.test(path)) return { path: '/account/auth', title: 'Вход и регистрация' }
  if (/^\/panel(\/|$)/.test(path)) {
    const parts = path.split('/')
    let section = parts[2]
    if (section === 'ai') section = parts[3] === 'assistant' ? 'assistant' : 'management'
    if (section === 'knowledge') section = 'management'
    const titles = { overview: 'Личный кабинет', assistant: 'Нейросеть GL', shop: 'Заказы магазина', study: 'Обучение', print: '3Д-печать', management: 'Управление ИИ' }
    if (!titles[section]) section = 'overview'
    return { path: `/account/${section}`, title: titles[section] }
  }
  return { path, title: '' }
}

function read (storage, key) {
  try { return JSON.parse(storage.getItem(key) || 'null') } catch { return null }
}
function saveVisit () {
  visit.updated = Date.now()
  try { window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(visit)) } catch {}
}
function context () {
  if (visit.updated && visit.updated < Date.now() - 30 * 60 * 1000) visit = { paymentAt: visit.paymentAt }
  // Staff is sticky within a visit, even after logout. No identity is transmitted.
  visit.staff ||= isManagerUser(store?.state?.auth?.user)
  try { visit.qa ||= window.localStorage.getItem('gl_analytics_qa') === '1' } catch {}
  saveVisit()
  return { gl_traffic: visit.qa ? 'qa' : visit.staff ? 'staff' : 'customer', gl_measurement: '2026-11-01' }
}
function call (...args) {
  try { if (active && allowed()) window.ym(COUNTER_ID, ...args) } catch { /* Analytics must never interrupt checkout. */ }
}

function safeReferrer (raw) {
  try {
    const url = new URL(raw)
    if (!['http:', 'https:'].includes(url.protocol)) return ''
    if (/(^|\.)(yoomoney\.ru|yookassa\.ru)$/.test(url.hostname)) return ORIGIN + '/shop/cart'
    if (['gorkyliquid.ru', 'www.gorkyliquid.ru'].includes(url.hostname)) return ORIGIN + analyticsPage(url.pathname).path
    // The referring host is sufficient for source attribution; query/path may contain personal data.
    return url.origin + '/'
  } catch { return '' }
}
function landingUrl (path) {
  const result = new URL(ORIGIN + path)
  if (path.startsWith('/account')) return result.href
  const params = new URLSearchParams(window.location.search || '')
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'yclid', 'gclid']) {
    const value = params.get(key)
    // Campaign labels are identifiers, not free text. Reject emails, URLs, phone numbers and template placeholders.
    if (!value || value.length > 120) continue
    const clickId = key === 'yclid' || key === 'gclid'
    if (clickId ? /^[\w-]{1,120}$/.test(value) : /^[\p{L}\p{N}_-]+$/u.test(value) && !/^\+?\d{10,}$/.test(value)) result.searchParams.set(key, value)
  }
  return result.href
}
function pageHit () {
  if (!pendingHit || !active) return
  clearTimeout(hitTimer)
  pendingHit = false
  const page = analyticsPage(currentPath)
  const url = initial ? landingUrl(page.path) : ORIGIN + page.path
  const title = page.title || (document.documentElement.dataset.glPagePath === currentPath ? document.title : 'Gorky Liquid')
  let referer = previousUrl
  if (initial) {
    referer = safeReferrer(document.referrer)
    // The PSP may omit referrer. A recent payment handoff identifies that return without retaining payment IDs.
    if (visit.paymentAt && Date.now() - visit.paymentAt < 60 * 60 * 1000 && new URLSearchParams(window.location.search || '').has('payment_attempt')) referer = ORIGIN + '/shop/cart'
  }
  call('hit', url, { title, referer, params: context() })
  previousUrl = ORIGIN + page.path
  initial = false
  if (/^\/study\/course\/[^/]+\/?$/.test(currentPath)) trackGoal('course_viewed', { kind: 'study' })
}
function scheduleHit () {
  pendingHit = true
  clearTimeout(hitTimer)
  if (document.documentElement.dataset.glPagePath === currentPath) pageHit()
  else hitTimer = setTimeout(pageHit, 5000) // A metadata failure must not hide the visit.
}

export function setupAnalytics (router, appStore) {
  if (installed || typeof window === 'undefined' || !allowed()) return
  installed = true
  store = appStore
  try {
    const cached = read(window.sessionStorage, SESSION_KEY)
    if (cached?.updated > Date.now() - 30 * 60 * 1000) visit = cached
    else if (cached?.paymentAt > Date.now() - 60 * 60 * 1000) visit.paymentAt = cached.paymentAt
  } catch {}
  currentPath = router.currentRoute.value.path
  window.ym = window.ym || function () { (window.ym.a = window.ym.a || []).push(arguments) }
  window.ym.l = window.ym.l || Date.now()
  window.dataLayer = window.dataLayer || []
  active = true
  call('init', {
    defer: true,
    ecommerce: 'dataLayer',
    accurateTrackBounce: true,
    webvisor: false,
    clickmap: false,
    trackLinks: false,
    url: landingUrl(analyticsPage(currentPath).path),
    referrer: safeReferrer(document.referrer)
  })
  if (!document.querySelector('script[data-gl-metrika]')) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://mc.yandex.ru/metrika/tag.js'
    script.dataset.glMetrika = 'true'
    document.head.appendChild(script)
  }
  document.addEventListener('gl-page-metadata', event => { if (event.detail?.path === currentPath) pageHit() })
  store?.watch?.(state => isManagerUser(state.auth?.user), () => call('params', context()))
  scheduleHit()
  router.afterEach((to, from, failure) => {
    if (failure || to.path === currentPath) return
    currentPath = to.path
    scheduleHit()
  })
}

function once (key, send) {
  if (!active || !allowed()) return
  try {
    const stored = read(window.localStorage, STORAGE_KEY)
    if (Array.isArray(stored)) stored.slice(-200).forEach(value => sent.add(value))
  } catch {}
  if (sent.has(key)) return
  send()
  sent.add(key)
  try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...sent].slice(-200))) } catch {}
}

export function trackGoal (name, { kind } = {}) {
  if (!active || !GOALS.has(name)) return
  call('reachGoal', name, { ...context(), ...(['shop', 'study', 'print', 'mixed'].includes(kind) ? { kind } : {}) })
}
function orderKind (items) {
  if (!items?.length) return 'shop'
  const courses = items.some(item => item.course_price || item.kind === 'course' || String(item.id).startsWith('course-'))
  const products = items.some(item => !item.course_price && item.kind !== 'course' && !String(item.id).startsWith('course-') && item.id !== 'delivery')
  return courses ? products ? 'mixed' : 'study' : 'shop'
}
export function trackCheckout (order, items) {
  if (!order?.id || order.reservation_status === 'released') return
  once(`checkout-${order.id}`, () => trackGoal('checkout_started', { kind: orderKind(items || order.order_items) }))
}
function ecommerce (data) {
  if (active && allowed()) {
    try { window.dataLayer.push({ ecommerce: { currencyCode: 'RUB', ...data } }) } catch {}
  }
}
function productData (product, quantity = 1) {
  return { id: String(product.course_price ? `course-${product.course_price}` : product.id), name: String(product.name || product.title || ''), price: Number(product.price), quantity, category: product.course_price ? 'Обучение' : 'Магазин' }
}
export function trackProductView (product) {
  if (!product?.id) return
  trackGoal('product_viewed', { kind: 'shop' })
  ecommerce({ detail: { products: [productData(product)] } })
}
export function trackCartAddition (product, quantity = 1) {
  if (!product?.id || !Number.isFinite(quantity) || quantity <= 0) return
  trackGoal('cart_added', { kind: product.course_price ? 'study' : 'shop' })
  ecommerce({ add: { products: [productData(product, quantity)] } })
}
export function trackPaymentRedirect (payment) {
  if (!active || !payment?.confirmation_url || payment.status !== 'pending') return
  visit.paymentAt = Date.now()
  saveVisit()
  once(`payment-redirect-${payment.id}`, () => trackGoal('payment_redirect', { kind: payment.kind }))
}
export function trackAssistantQuestion () {
  if (!active) return
  context()
  if (visit.aiQuestion) return
  trackGoal('ai_first_question')
  visit.aiQuestion = true
  saveVisit()
}
export function trackVerifiedPurchase (payment) {
  if (payment?.test_mode !== false || payment?.is_paid !== true || payment?.status !== 'succeeded') return
  const data = payment.analytics
  if (!data?.id || !Array.isArray(data.products) || !data.products.length || !(Number(data.revenue) > 0)) return
  once(`purchase-${data.id}`, () => {
    const kind = payment.kind === 'shop' ? orderKind(data.products) : payment.kind
    if (context().gl_traffic === 'qa') { trackGoal('qa_purchase', { kind }); return }
    trackGoal('payment_succeeded', { kind })
    ecommerce({
      purchase: {
        actionField: { id: String(data.id), revenue: Number(data.revenue) },
        products: data.products.map(product => ({ id: String(product.id), name: String(product.name), price: Number(product.price), quantity: Number(product.quantity) }))
      }
    })
  })
}
